module.exports = __webpack_public_path__ + "static/media/icon-Amex.ab4943e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Amex.svg
// module id = 2900
// module chunks = 0